import React, { useEffect, useState, useRef } from "react";
import { Chart, Series, CommonSeriesSettings } from "devextreme-react/chart";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";
import { Card, Col, Row, Stack, Alert } from "react-bootstrap";

const override = {
  display: "block",
  margin: "0 auto",
};
const Rides = () => {
  const ridesarr = [];
  const [rides, setRides] = useState([]);
  const effectRan = useRef(false);
  const [loading, setLoading] = useState(false);
  const { apiKey } = useParams();

  const getRides = async () => {
    setLoading(true);
    const res = await fetch("api/Rides/GetRidesTenant/" + apiKey);
    if (res.ok) {
      const data = await res.json();
      setRides(data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  useEffect(() => {
    getRides();

    const autoR = setInterval(() => {
      getRides();
    }, 15*60*1000);

    return () => clearInterval(autoR);
  }, []);

  function changeFormatting() {
    ridesarr.push({
      value: rides.rentalsEnded,
      arguments: "Beëindigde ritten",
    });
    ridesarr.push({
      value: rides.rentalsStarted,
      arguments: "Gestartte ritten",
    });
    ridesarr.push({
      value: rides.rentalsReserved,
      arguments: "Gereserveerde ritten",
    });
  }
  changeFormatting();

  return (
    <>
      <Card>
        <Card.Header className="fw-bold text-center fs-5">
          Ritten in afgelopen 24 uur
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div>
              <ClipLoader
                color="#5b36d6"
                loading={loading}
                cssOverride={override}
                speedMultiplier="0.8"
                size={35}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <Chart dataSource={ridesarr} commonAxisSettings={{allowDecimals: false}}>
              <CommonSeriesSettings
                argumentField="arguments"
                type="bar"
                barPadding={0.8}
              />
              <Series valueField="value" showInLegend={false} />
            </Chart>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default Rides;
